import { Control, Controller } from "react-hook-form";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DUEDATE_NAME, STATUS_NAME, TASK_NAME, TYPE_NAME } from "./constant";
import InputBox from "@/components/Form/InputBox/InputBox";
import { EditSummaryFormType } from "./type";

type ControlInputBoxType = {
  required?: boolean;
  isTextArea?: boolean;
  control: Control<EditSummaryFormType>;
  name: typeof TASK_NAME | typeof TYPE_NAME | typeof DUEDATE_NAME | typeof STATUS_NAME;
  showLabel: boolean;
  label: string;
  readonly?:boolean;
};

export default function ControlInputBox({
  name,
  control,
  required = false,
  isTextArea = false,
  showLabel,
  label,
  readonly
}: ControlInputBoxType) {
  const { field } = useController({
    name,
    control,
    rules: { required: required },
  });
  const { t } = useTranslation();

  return (
    <>
      {showLabel && (
        <div className="formFieldLabel">
          <label htmlFor="input" aria-label={label}>
            {t(label)}
            {required ? <span className="requiredSymbol">*</span> : ""}
          </label>
        </div>
      )}
      <Controller
        name={field.name}
        control={control}
        rules={{ required }}
        render={({ field: { onChange, value, ...args } }) => {
          return (
            <>
              <InputBox
                id={TASK_NAME}
                required={true}
                value={value || ""}
                onChange={onChange}
                isTextArea={isTextArea}
                readonly={readonly}
                {...args}
              />
            </>
          );
        }}
      />
    </>
  );
}
